import { TABS_INDEX } from './AssistantSignUp';

import { Box } from 'src/components/UI/Box';
import { Flex } from 'src/components/UI/Flex';
import Typography from 'src/components/Typography';

import { colors } from 'src/theme/colors';

import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { TabHeaderButton } from './TabHeaderButton';

interface TabsHeaderProps {
  isFirstStepCompleted?: boolean;
  tabClick(index: number): void;
  currentIndex: number;
}

export function TabsHeader(props: TabsHeaderProps) {
  const { tabClick, isFirstStepCompleted } = props;

  const handleTabClick = (tabIndex: number) => {
    tabClick(tabIndex);
  };

  return (
    <Flex
      bg={'surface'}
      border={'1px solid'}
      borderColor={{ base: 'surface', sm: 'primary.50' }}
      p={'10px'}
      borderRadius={'20px'}
      mt={'20px'}
      mb={'30px'}
      justifyContent={'space-between'}
    >
      <TabHeaderButton
        isSelected={props.currentIndex === TABS_INDEX.PERSONAL_DATA}
        onClick={() => handleTabClick(TABS_INDEX.PERSONAL_DATA)}
      >
        <Box mr={'5px'}>
          <Check fill={isFirstStepCompleted ? colors.notification.success : colors.primary['1000']} />
        </Box>
        <Typography model={'caption'} weight={'bold'}>
          Passo 1
        </Typography>
      </TabHeaderButton>
      <TabHeaderButton
        isSelected={props.currentIndex === TABS_INDEX.CREATE_PASSWORD}
        onClick={() => handleTabClick(TABS_INDEX.CREATE_PASSWORD)}
      >
        <Box mr={'5px'}>
          <Check fill={colors.primary['1000']} />
        </Box>
        <Typography model={'caption'} weight={'bold'}>
          Passo 2
        </Typography>
      </TabHeaderButton>
    </Flex>
  );
}
